import Yup from 'utils/validation/yup-extensions';

/**
 * Form property keys.
 * @type {object}
 */
export const FORM_KEYS = {
	RENEWALDATA: 'newRenewalDate',
};

/**
 * Default Formik form initial value object.
 * @type {object}
 */
export const FORM_INITIAL_VALUES = {
	[FORM_KEYS.RENEWALDATA]: false,
};

/**
 * Default Formik form Yup validation schema object.
 * @type {object}
 */
export const FORM_VALIDATION_SCHEMA = {
	[FORM_KEYS.RENEWALDATA]: Yup.date()
		.required('Please provide a valid future date.')
		.max(
			new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
			'The date provided is more than one year in the future.'
		)
		.min(
			new Date() + 1,
			'The date provided is not in the future.  Please provide a future date.'
		),
};
